import { useEffect } from 'react';

/**
 * Warns before browser tab close if there are unsaved changes.
 */
export default function useUnsavedChanges(isDirty) {
  useEffect(() => {
    if (!isDirty) return;
    const handler = e => {
      e.preventDefault();
      e.returnValue = '';
    };
    window.addEventListener('beforeunload', handler);
    return () => window.removeEventListener('beforeunload', handler);
  }, [isDirty]);
}
